
/*
Copyright 2024 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import { useEffect, useState } from 'react';
import i18next from './i18next'
import { useTranslation as useTranslationOrg } from 'react-i18next';
import Cookies from 'js-cookie';
import { headerName } from './settings';

const RUNS_ON_SERVER_SIDE = typeof window === 'undefined';

export function useTranslation(ns: any, lng?: any, options?: any) {
  const ret = useTranslationOrg(ns, options)

  if (lng && i18next.resolvedLanguage !== lng) {
    i18next.changeLanguage(lng)
  }

  if (RUNS_ON_SERVER_SIDE && lng && i18next.resolvedLanguage !== lng) {
    i18next.changeLanguage(lng)
  } else {

    const [activeLng, setActiveLng] = useState(i18next.resolvedLanguage)

    useEffect(() => {
      if (activeLng === i18next.resolvedLanguage) return
      setActiveLng(i18next.resolvedLanguage)
    }, [activeLng])

    useEffect(() => {
      if (!lng || i18next.resolvedLanguage === lng) return
      i18next.changeLanguage(lng)
    }, [lng])
    
    if(RUNS_ON_SERVER_SIDE) {
      // if (getCookie(headerName) !== lng) {
      //   setCookie(headerName, lng);
      // }
    } else {
      useEffect(() => {
        if (Cookies.get(headerName) !== lng) {
          Cookies.set(headerName, lng);
        }
      })
    }
  }

  return ret
}